import React from "react";
import { AiOutlineClose } from "react-icons/ai";

const WarningModal = ({ open, handleClose }) => {
  if (!open) return null; // Only render modal if open is true

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-md shadow-lg w-1/3 outline-none">
        <div className="flex items-center justify-between mb-3">
          <div className="font-bold text-[22px] text-[#161412]">Pending Approval</div>
          <button onClick={handleClose} className="text-gray-600 hover:text-gray-800">
            <AiOutlineClose size={24} />
          </button>
        </div>
        <div className="mt-2 text-gray-700">
          Your sign-up request is pending approval from the administrator. Please contact your administrator for further
          assistance.
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={handleClose}
            className="mr-2 px-4 py-2 bg-gray-300 rounded hover:bg-gray-400  text-[#161412]"
          >
            Okay, Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
